import React, {ReactElement} from 'react'
import {Dialog} from '@mui/material'
import {MainContainer} from '../../../../styledComponents/ContentsArea'
import {StyledButton, StyledImg} from '../../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {Colors, FontSize, FontWeights} from '../../../../styledComponents/Constants'
import {Nullable} from '../../../../app/TypeHelpers'
import EventEmitterExResident from '../../../../components/shared/pageBaseComponents/EventEmitterExResident'
import {Close} from '@mui/icons-material'
import {Location, NavigateFunction} from 'react-router-dom'

interface Props {
    open: boolean,
    closeImageDialog: () => void
    imagePath: string
    imageFileName: string
    navigate: NavigateFunction
    location: Location
}

interface States {
    isLoadCompleted: boolean
}

interface ExternalProps {
    eventEmitter: EventEmitterExResident
}


class NatResidentImageDialogComponent extends React.Component<Props & ExternalProps, States> {

    constructor(props: Props & ExternalProps) {
        super(props);

        this.state = {
            isLoadCompleted: false,
        };
    }

    async componentDidMount(): Promise<void> {
        this.setState({isLoadCompleted: true})
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <Dialog
                    open={this.props.open}
                    fullWidth
                    maxWidth={'md'}
                >
                    <MainContainer>
                        <DialogCloseButton onClick={this.props.closeImageDialog} id={'close'}>
                            <Close fontSize={'large'}/>
                        </DialogCloseButton>
                        <DialogImage src={`${this.props.imagePath}?${new Date().getTime()}`}
                                     alt={this.props.imageFileName}/>
                    </MainContainer>
                </Dialog>
            </>
        )
    }
}

export default NatResidentImageDialogComponent

export const DialogImage: StyledImg = styled.img`
  width: 100%;
  height: auto;
`;

export const DialogCloseButton: StyledButton = styled.button`
  cursor: pointer;
  color: ${Colors.AccentDark};
  font-size: ${FontSize.Body};
  line-height: ${FontSize.Body};
  font-weight: ${FontWeights.Normal};
  outline: none;
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  background-color: transparent;
  padding: 0 0 0 0;
  display: block;
  box-sizing: border-box;
  border: none;
  height: 44px;
  width: 44px;
  margin: 0 0 0 auto;
  padding-bottom: 10px;
`;
